module.exports = __webpack_public_path__ + "static/about-2-21e20c3d219337cb4ead6ee017033015.jpg";